import { REQUEST_TIMEOUT_MS } from '@ctcells/core'

import { orchestrator } from '../clients.ts'
import { createCommand } from '../command.ts'
import type { RecipeV2Doc } from '../queries/templates.ts'

/*
 * ⚠ 레시피 v2 템플릿 쓰기 훅(`POST` · `PUT` · `DELETE /templates/{kind}…`)은 2026-10-26 걷었다 — 템플릿 화면이 «레시피» 하나만 남아
 *   (eric 「응.. 다 빼줘」) 부르는 곳이 0이 됐다. 서버 경로는 그대로다(`app/views/templates_v2.py`). 다시 붙일 때는 PUT 이 전체 교체라
 *   «받은 행 위에 고친 칸만» 얹어 보내야 한다(CLAUDE.md 「PUT 은 받은 것 위에 고친 칸만」).
 */

/** `POST /recipes/validate` 한 항목 — 서버 `ValidationIssue` 의 `asdict` 그대로(`code` · `message` · `field` · `step_seq`) */
export interface RecipeV2Issue {
  code: string
  message: string
  field?: string | null
  step_seq?: number | null
}

/**
 * 새 형식 레시피 검증 결과 — 서버 원문 「응답 200 `{valid, errors, warnings, compile}`」. 합격 · 불합격 모두 200.
 * `compile` = 전개 요약(`tips` · `unresolved` · `ruleset_version`) 또는 `{error}`.
 */
export interface RecipeV2Validation {
  valid: boolean
  errors: readonly RecipeV2Issue[]
  warnings: readonly RecipeV2Issue[]
  compile: Readonly<Record<string, unknown>>
}

/**
 * 편집기 「검증」 — 🔴 **검증은 서버 컴파일러가 한다**(서버 원문 사용자 지시 「편집기 검증은 프런트에서 하면 안되고 백엔드에서
 * 컴파일러에서 검증시키고 검증결과 넘겨야 한다」). DB · 감사 없음 · 쓰기 역할(operator/admin).
 */
export const useValidateRecipeV2 = createCommand<{ doc: RecipeV2Doc }, RecipeV2Validation>({
  send: ({ doc }) =>
    orchestrator.request<RecipeV2Validation>({
      method: 'POST',
      path: '/recipes/validate',
      body: doc,
      timeoutMs: REQUEST_TIMEOUT_MS.command,
      retryOn401: true,
    }),
  invalidates: () => [],
})
